import { useAuth } from "@/context/AuthContext";

/** Whether the signed-in user may trigger Ace calibration (admin only). */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  const permissions = user.permissions ?? [];
  return (
    user.role === "admin" ||
    user.role === "super_admin" ||
    permissions.includes("*") ||
    permissions.includes("admin:*")
  );
}
